<template>
  <div class="chunk">
    <div class="search">
      <div class="search-list">
        <div
          class="search-list-children"
          v-for="(item, index) in searchList"
          :key="index"
          :style="{'margin-top': index !== 0 ? '10px' : '0px'}"
          @click="goArticle(item)"
        >
          <div class="search-list-content">
            <div class="search-list-title">{{item.title}}</div>
            <div class="search-list-text">{{item.brief}}</div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="searchList.length > 0">
        <Page
          :total="searchTotal"
          :page-size="10"
          :current.sync="searchCurrent"
          show-total
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchList: [],
      searchTotal: 0,
      searchCurrent: 1
    };
  },
  created() {
    this.getSearchList(this.searchCurrent);
  },
  methods: {
    getSearchList(index) {
      this.$http
        .get(
          `/open/cms/article/search/${this.$route.query.keyword}?page=${index}&limit=10`
        )
        .then(res => {
          this.searchList = res.data.data;
          this.searchTotal = res.data.meta.total;
        });
    },
    changePage(index) {
      this.getSearchList(index);
    },
    goArticle(item) {
      this.$http
        .get(`/open/cms/category?filter=id||eq||${item.categoryId}`)
        .then(res => {
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$store.commit("eidtBreadcrumb", data.data.data[0].id);
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: "article",
                    selectMoreId: res.data.data[0].id,
                    articleId: item.id
                  }
                });
              });
          } else {
            this.$store.commit("eidtBreadcrumb", res.data.data[0].id);
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: "article",
                articleId: item.id
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.chunk {
  padding-bottom: 116px;
}
.search {
  min-height: 70%;
  width: 1200px;
  background: #fff;
  padding: 16px;
  &-list {
    &-children {
      display: flex;
      width: 100%;
      cursor: pointer;
      border-bottom: 1px dashed #666;
    }
    &-img {
      width: 90px;
      height: 90px;
      margin: 5px 0 0 5px;
    }
    &-content {
      margin-top: 5px;
      margin-left: 16px;
    }
    &-title {
      font-size: 18px;
      &:hover {
        color: #ff9240;
      }
    }
    &-text {
      font-size: 14px;
      margin-top: 10px;
      color: #666;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin: 20px 12px 0 0;
}
</style>